import '@f-fertighaus/layout/PageHeader/SSR/PageHeaderSSR'
import '@f/components/PageSharing'
import '@js/common/site-wide'
import '@js/common/request-flow-triggers'

import React from 'react'
import { createRoot } from 'react-dom/client'

import { get } from '@js/common/api'

import ProximityCheck from '@f/components/ProximityCheck'
import CardCarousel from '@f/widgets/CardCarousel'

import VendorSalesAgentsList from '@f-fertighaus/templates/VendorOfficeDetailPage/partials/VendorSalesAgentsList'

void (function () {
  var elements = document.getElementsByClassName('js-guard-element')
  for (const element of elements) {
    element.addEventListener('click', evt => {
      evt.preventDefault()
      const phone = document.createElement('a')
      phone.className = 'CTA-text-primary [ f-t-body ]'
      phone.href = `tel:${element.dataset.guardContent}`
      phone.innerText = element.dataset.guardContent

      element.insertAdjacentElement('afterend', phone)

      element.parentNode.removeChild(element)
    })
  }
})()

void (() => {
  const unfoldElements = document.querySelectorAll('.js-unfold-stories')

  for (const unfoldElement of unfoldElements) {
    unfoldElement.addEventListener('click', event => {
      const { target } = event
      target.parentNode.classList.add('f-hidden')
      target.parentNode.parentNode
        .querySelector('.js-unfold-stories-content')
        .classList.remove('f-hidden')
    })
  }
})()

void (() => {
  const unfoldElements = document.querySelectorAll('.js-unfold')

  for (const unfoldElement of unfoldElements) {
    unfoldElement.addEventListener('click', event => {
      const { target } = event
      target.classList.add('f-hidden')
      target.parentNode
        .querySelector('.js-unfold-content')
        .classList.remove('f-hidden')
    })
  }
})()

void (() => {
  document.onreadystatechange = () => {
    if (document.readyState === 'complete') {
      if (SherlockContainer.isPremiumProfile) {
        var el = document.getElementById('map-location')
        if (SherlockContainer.location) {
          var map = new google.maps.Map(el, {
            zoom: 10,
            center: SherlockContainer.location,
            mapId: window.SherlockContainer?.environment?.GM_MAP_ID
          })
          new google.maps.marker.AdvancedMarkerElement({
            position: SherlockContainer.location,
            map: map
          })
        } else {
          el.style.display = 'none'
        }
      }
    }
  }
})()

const carouselMountPoint = document.getElementById('carousel-mountpoint')
if (carouselMountPoint) {
  get('houses', { vendor_nid__in: SherlockContainer.vendorNid }).then(
    response => {
      if (response.results.length > 0) {
        const root = createRoot(carouselMountPoint)
        root.render(
          <>
            <h2 className='[ f-t-tminor f-m-a-0 f-p-v-020 ]'>{`Häuser von ${SherlockContainer.vendorName}`}</h2>
            <CardCarousel
              items={response.results}
              item_nid_type='house_nid'
              card='house-small'
              wtData={{
                'item-collection': {
                  label: 'house-carousel'
                },
                item: {
                  label: 'card-house-standard',
                  location: 'house-carousel'
                }
              }}
            />
          </>
        )
      }
    }
  )
}

/* Proximity Check */
void (function () {
  const mountPoints = document.querySelectorAll('.js-proximity')
  for (const mountPoint of mountPoints) {
    const root = createRoot(mountPoint)
    root.render(
      <ProximityCheck
        deliveryRegions={
          window.SherlockContainer.deliveryRegions ||
          window.SherlockContainer.details.deliveryRegions
        }
        alternativeMessage={mountPoint.dataset.hasOwnProperty(
          'alternativeMessage'
        )}
        vendorName={mountPoint.dataset.vendorName}
        version='text'
      />
    )
  }
})()

/* Sales Agents Profiles*/

void (() => {
  const mountPoint = document.getElementById('VendorOfficeDetail-sales-agents')

  if (mountPoint) {
    mountPoint.innerHTML = ''
    const root = createRoot(mountPoint)
    root.render(
      <VendorSalesAgentsList
        vendorNid={SherlockContainer.vendorNid}
        officeNid={SherlockContainer.officeNid}
      />
    )
  }
})()

void (function () {
  const mountPoints = document.querySelectorAll(
    '.VendorOfficesSidebar-local-sales-agent'
  )

  for (const mountPoint of mountPoints) {
    mountPoint.innerHTML = ''
    const root = createRoot(mountPoint)
    root.render(
      <VendorSalesAgentsList
        vendorNid={SherlockContainer.vendorNid}
        officeNid={SherlockContainer.officeNid}
        isLocalSalesAgent
      />
    )
  }
})()
